import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    pdfButton: {
      color: palette.green,
      borderColor: palette.green,
      padding: '0px 6px',
    },
    menuItem: {
      fontSize: 12,
      fontWeight: 500,
      justifyContent: 'space-between',
      alignItems: 'center',

      '&:hover': {
        backgroundColor: palette.superLightGreen,
      },
    },
  });
